import { fetchAuthSession } from "@aws-amplify/auth";
import {
	APIGatewayClient,
	GetStagesCommand,
} from "@aws-sdk/client-api-gateway";
import { onMounted, ref } from "vue";

export interface Stage {
	Name: string; // The name of the API Gateway stage
	LambdaAlias: string; // The alias of the Lambda function associated with the stage
}

export async function listStages(
	restApiId: string,
	region: string = "us-east-1",
): Promise<Stage[] | undefined> {
	const credentials = (await fetchAuthSession()).credentials;

	// Configuration for the APIGatewayClient
	const config = {
		region: region,
		credentials: credentials,
	};

	// Initialize the API Gateway client
	const client = new APIGatewayClient(config);

	// Input for the GetStagesCommand
	const input = {
		restApiId: restApiId,
	};

	const command = new GetStagesCommand(input);

	try {
		// Send the command and await the response
		const response = await client.send(command);

		// Convert the response to a list of stages
		return response.item?.map(stage => ({
			Name: stage.stageName,
			LambdaAlias: stage.variables?.lambdaAlias,
		})) as Stage[];
	} catch (error) {
		console.error(error);
		throw error;
	}
}

export function useApiGatewayStage(
	restApiId: string,
	region: string = "us-east-1",
) {
	const stages = ref<Stage[]>();
	const errorMessage = ref<string>();

	onMounted(async () => {
		try {
			stages.value = await listStages(restApiId, region);
		} catch (error: unknown) {
			console.error("List stages error: ", error);
			errorMessage.value = "Error loading stage list";
		}
	});

	return { stages, errorMessage };
}
